// components
import Image from 'next/image';
import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';
import Link from '@/components/utilities/SmartLink';

// utilities
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { getImagePath } from '@/utils/images';
import { getDocPath } from '@/utils/docs';

const MaterialsBlock = ({ items }) => {
  return (
    <div className="mx-auto my-10 w-[90vw] xl:w-(--container-width)">
      <div className="-mx-3 mb-16 flex flex-wrap justify-center gap-y-6 xl:mb-32">
        {items.map((item, index) => (
          <VisibleLoading key={item.id} delay={((index % 2) + 1) * 200}>
            {({ ref, className }) => (
              <div ref={ref} className={`basis-full px-3 xl:basis-1/2 ${className || ''}`.trim()}>
                <div className="flex h-full flex-col gap-4 rounded-2xl bg-white p-4 shadow-2xl/15">
                  <div className="h-[300px] overflow-hidden rounded-2xl">
                    {item.image && (
                      <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl bg-black/5">
                        <Image src={getImagePath(item.image)} alt={item.name} fill={true} className="object-cover" />
                      </div>
                    )}
                  </div>

                  <div className="flex-1">
                    <div className="txt-md mb-4 font-semibold uppercase">{item.subtitle}</div>
                    <h6 className="mb-3 line-clamp-2 min-h-[56px]">{item.name}</h6>

                    <div className="txt-lg text-grey-700 line-clamp-4">{item.description}</div>
                  </div>

                  <div className="flex">
                    <Button asChild={true} className="basis-full xl:basis-auto">
                      <Link
                        href={getDocPath(item.doc)}
                        target="_blank"
                        rel="noopener noreferrer"
                        downloads={item.doc.name}
                      >
                        <Icon type="documentDownload" /> {item.button.label}
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </VisibleLoading>
        ))}
      </div>
    </div>
  );
};
export default MaterialsBlock;
